import React from 'react';
import Image from 'next/image';
import styles from './CustomSingleLogo.module.scss';
import classNames from 'classnames';
import { useCustomOrgContext } from '@/context/customOrgContext';
const CustomSingleLogo = () => {
  const {
    CustomOrg
  } = useCustomOrgContext();
  return <>
   <div className={classNames(CustomOrg?.template ? styles['primary-' + CustomOrg?.template] : '', styles['custom-logo'], styles['primary-logo'])} data-bdd={'primary-client-logo'}>
    <Image data-bdd={'bdd-client-logo'} src={CustomOrg?.logo1?.url} alt={'client-logo'} priority={true} width={CustomOrg?.logo1?.width} height={CustomOrg?.logo1?.height} unoptimized={true} data-sentry-element="Image" data-sentry-source-file="CustomSingleLogo.tsx" />
   </div>
  </>;
};
export default CustomSingleLogo;